import { useState,useEffect } from "react";
import { Box,Table,Thead,Tbody,Tr,Th,Td,TableContainer,Menu,MenuButton,MenuList,MenuItem,IconButton } from "@chakra-ui/react"
import { HamburgerIcon,DeleteIcon } from "@chakra-ui/icons";
import GruntPager from "../custom/GruntPager";

export const SpecifikacijaOdabranaGovedaTable=({goveda=[],organizatori=[],tableSize='xs',onRemoveGovedo,readonly=false})=>{
const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",rowsperpage:18,currpage:1});

useEffect(() => {
  setPrikaz({...prikaz,currpage:1});
}, [goveda])


const getPopis=(item)=>{
    let res="";
    if (item.popis_rgg_id!==0) {
        res=`${item.popis_rgg_id}  - (${new Date(item.popis_datum.split("T")[0]).toLocaleDateString("hr-HR")})`;
    } else {
        res="--"
    }
    return res;
}
const getSpol=(spol)=>{
    if (spol.toLowerCase()==="m") {
        return "M";
    } else {
        return "Ž";
    }
}


const getMenu=(item)=>{
    if (item.popis_rgg_id===0) {
        return (
            <Menu size={tableSize} zIndex={1}>
                                <MenuButton
                                    as={IconButton}
                                    aria-label='Options'
                                    icon={<HamburgerIcon />}
                                    variant={'outline'} size={tableSize}
                                />
                                <MenuList>
                                    <MenuItem isDisabled={readonly} onClick={()=>onRemoveGovedo(item.govedo_id)} size={tableSize} icon={<DeleteIcon color={'red.700'}/>}>Ukloni</MenuItem>
                                </MenuList>
                              </Menu>
        )
    }
    else {
        return null;
    }
}

const orderGoveda=(a,b)=>{
    if (a.putnica_oznaka>b.putnica_oznaka) {
        return 1;
    } else {
        return -1;
    }
}

const buildScreen=()=>{
    return (
        <Box display={'flex'} flexDirection={'column'} flex={1}>
        <TableContainer>
            <Table variant={'unstyled'} size={tableSize}>
                <Thead _hover={{cursor:'pointer'}} fontSize={tableSize}>
                    <Tr>
                        <Th w={'3%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Rbr</Th>
                        <Th w={'3%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                        <Th w={'25%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Popis</Th>
                        <Th w={'15%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Zivotni broj</Th>
                        <Th w={'5%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                        <Th w={'25%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                        <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Put. ozn.</Th>
                        <Th w={'27%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Knjiga</Th>
                        
                    </Tr>
                </Thead>
                <Tbody>
                {goveda.sort(orderGoveda).slice((prikaz.currpage-1)*prikaz.rowsperpage,prikaz.currpage*prikaz.rowsperpage).map((item,i)=>{
                      return (
                        <Tr  color={'grunt2'} key={item.govedo_id}  bg={'white'} fontWeight={'normal'} 
                        _hover={{bg:'gray.100',cursor:'pointer'}} h='2rem'>
                            <Td fontSize={tableSize} textAlign={'center'}>
                              {(prikaz.currpage-1)*(prikaz.rowsperpage)+(i+1)}.
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                {getMenu(item)}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                              {getPopis(item)}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                {item.zivbr}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>
                              {getSpol(item.spol)}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                    {item.pasmina}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                    {item.putnica_oznaka}
                            </Td>
                            <Td fontSize={tableSize} textAlign={'center'}>
                                    {item.knjiga}
                            </Td>
                            
                        </Tr>
                      )
                })}
                </Tbody>
                </Table>
          </TableContainer>
    </Box>
    )
}


const getPager=()=>{
    if (goveda.length>0) {
        return (
            <Box display={'flex'} flexDir={'rov'} alignItems={'center'} justifyContent={'center'}>
                <GruntPager currpage={prikaz.currpage} rowcount={goveda.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
            </Box>
        )    
    }
    
}
return (
    <Box display={'flex'} flexDirection={'column'} flex={1}>
        {buildScreen()}
        {getPager()}
    </Box>
)

}